import React, { useEffect, useMemo, useRef, useState } from "react";
import Sidebar from "./SideBar.js";
import PortfolioFooter from "./PortfolioFooter";
import "./AboutMe.css";

import songImg1 from "./assets/song_img_1.png";
import vinylImg1 from "./assets/vinyl_img_1.png";
import songImg2 from "./assets/song_img_2.png";
import vinylImg2 from "./assets/vinyl_img_2.png";
import songImg3 from "./assets/song_img_3.png";
import vinylImg3 from "./assets/vinyl_img_3.png";
import songImg4 from "./assets/song_img_4.png";
import vinylImg4 from "./assets/vinyl_img_4.png";

import movImg1 from "./assets/mov_img_1.png";
import movImg2 from "./assets/mov_img_2.png";
import movImg3 from "./assets/mov_img_3.png";
import movImg4 from "./assets/mov_img_4.png";
import movImg5 from "./assets/mov_img_5.png";
import movImg6 from "./assets/mov_img_6.png";

import BookImg1 from "./assets/book_img_1.png";
import BookImg2 from "./assets/book_img_2.png";
import BookImg3 from "./assets/book_img_3.png";
import BookImg4 from "./assets/book_img_4.png";
import BookImg5 from "./assets/book_img_5.png";
import BookImg6 from "./assets/book_img_6.png";

import CertImg1 from "./assets/Certificate_img_1.png";
import CertImg2 from "./assets/certificates/adobe_certificate.jpg";
import CertImg3 from "./assets/certificates/certificate_img_3.jpeg";
import CertImg4 from "./assets/certificates/certificate_img_4.jpeg";
import CertImg5 from "./assets/certificates/certificate_img_5.jpeg";

import CertImg6 from "./assets/certificates/Claude_101.png";
import CertImg7 from "./assets/certificates/Claude_Action.png";
import CertImg9 from "./assets/certificates/Anthropic_API.png";
import CertImg10 from "./assets/certificates/LangChain_Essentials.png";
import CertImg11 from "./assets/certificates/LangGraph_Essentials.png";
import CertImg12 from "./assets/certificates/Deep_Agents.png";

import CertPdf1 from "./assets/certificates/SAP_CERTIFICATE.pdf";

import CertPdf2 from "./assets/certificates/Claude_101.pdf";
import CertPdf3 from "./assets/certificates/Claude_Action.pdf";
import CertPdf4 from "./assets/certificates/Anthropic_API.pdf";
import CertPdf5 from "./assets/certificates/LangChain_Essentials.pdf";
import CertPdf6 from "./assets/certificates/LangGraph_Essentials.pdf";
import CertPdf7 from "./assets/certificates/Project_Deep_Agents.pdf";

import UserImg1 from "./assets/user_img_1.jpg";
import UserImg2 from "./assets/user_img_2.jpg";

import EventImg1 from "./assets/event_img_1.jpg";
import EventImg2 from "./assets/event_img_2.jpeg";
import EventImg3 from "./assets/event_img_3.png";
import EventImg4 from "./assets/event_img_4.jpg";

import StampImg1 from "./assets/stamp_img_1.png";
import StampImg2 from "./assets/stamp_img_2.png";
import StampImg3 from "./assets/stamp_img_3.png";
import StampImg4 from "./assets/stamp_img_4.png";
import StampImg5 from "./assets/stamp_img_5.png";

const PLACEHOLDER1 = songImg1;
const PLACEHOLDER2 = songImg2;
const PLACEHOLDER3 = songImg3;
const PLACEHOLDER4 = songImg4;

const VINYL_PLACEHOLDER1 = vinylImg1;
const VINYL_PLACEHOLDER2 = vinylImg2;
const VINYL_PLACEHOLDER3 = vinylImg3;
const VINYL_PLACEHOLDER4 = vinylImg4;

const MOV_PLACEHOLDER1 = movImg1;
const MOV_PLACEHOLDER2 = movImg2;
const MOV_PLACEHOLDER3 = movImg3;
const MOV_PLACEHOLDER4 = movImg4;
const MOV_PLACEHOLDER5 = movImg5;
const MOV_PLACEHOLDER6 = movImg6;

const BOOK_PLACEHOLDER1 = BookImg1;
const BOOK_PLACEHOLDER2 = BookImg2;
const BOOK_PLACEHOLDER3 = BookImg3;
const BOOK_PLACEHOLDER4 = BookImg4;
const BOOK_PLACEHOLDER5 = BookImg5;
const BOOK_PLACEHOLDER6 = BookImg6;

const CERT_PLACEHOLDER1 = CertImg1;
const CERT_PLACEHOLDER2 = CertImg2;
const CERT_PLACEHOLDER3 = CertImg3;
const CERT_PLACEHOLDER4 = CertImg4;
const CERT_PLACEHOLDER5 = CertImg5;


const CERT_PDF1 = CertPdf1;
const CERT_PDF2 = CertPdf2;
const CERT_PDF3 = CertPdf3;
const CERT_PDF4 = CertPdf4;
const CERT_PDF5 = CertPdf5;
const CERT_PDF6 = CertPdf6;
const CERT_PDF7 = CertPdf7;

const USER_PLACEHOLDER1 = UserImg1;
const USER_PLACEHOLDER2 = UserImg2;

const EVENT_PLACEHOLDER1 = EventImg1;
const EVENT_PLACEHOLDER2 = EventImg2;
const EVENT_PLACEHOLDER3 = EventImg3;
const EVENT_PLACEHOLDER4 = EventImg4;

const STAMP_PLACEHOLDER1 = StampImg1;
const STAMP_PLACEHOLDER2 = StampImg2;
const STAMP_PLACEHOLDER3 = StampImg3;
const STAMP_PLACEHOLDER4 = StampImg4;
const STAMP_PLACEHOLDER5 = StampImg5;

const SONGS = [
  {
    title: "4:44",
    artist: "Jay-Z",
    cover: PLACEHOLDER1,
    vinyl: VINYL_PLACEHOLDER1,
  },
  {
    title: "Pyramids",
    artist: "Frank Ocean",
    cover: PLACEHOLDER2,
    vinyl: VINYL_PLACEHOLDER2,
  },
  {
    title: "Cudi Montage",
    artist: "Kid Cudi & Kanye West",
    cover: PLACEHOLDER3,
    vinyl: VINYL_PLACEHOLDER3,
  },
  {
    title: "No Church in the Wild",
    artist: "Jay-Z & Kanye West",
    cover: PLACEHOLDER4,
    vinyl: VINYL_PLACEHOLDER4,
  },
];

const FAVORITES = [
  {
    label: "Favourite Books",
    subtitle:
      "Stories that shaped how I think about worlds, systems, and people.",
    items: [
      {
        title: "The Laws of Human Nature",
        author: "Robert Greene",
        image: BOOK_PLACEHOLDER1,
      },
      {
        title: "The Design of Everyday Things",
        author: "Don Norman",
        image: BOOK_PLACEHOLDER2,
      },
      {
        title: "The Creative Act",
        author: "Rick Rubin",
        image: BOOK_PLACEHOLDER3,
      },
      {
        title: "User Friendly",
        author: "Cliff Kuang",
        image: BOOK_PLACEHOLDER4,
      },
      {
        title: "Steal Like an Artist",
        author: "Austin Kleon",
        image: BOOK_PLACEHOLDER5,
      },
      {
        title: "The Martian",
        author: "Andy Weir",
        image: BOOK_PLACEHOLDER6,
      },
    ],
  },
  {
    label: "Favourite Movies",
    subtitle:
      "Films I return to for atmosphere, pacing, and visual storytelling.",
    items: [
      { title: "The Sopranos", image: MOV_PLACEHOLDER1 },
      { title: "Succession", image: MOV_PLACEHOLDER2 },
      { title: "Casino", image: MOV_PLACEHOLDER3 },
      { title: "Seven", image: MOV_PLACEHOLDER4 },
      { title: "Tenet", image: MOV_PLACEHOLDER5 },
      { title: "Severance", image: MOV_PLACEHOLDER6 },
    ],
  },
];

const CERTIFICATIONS = [
  {
    image: CERT_PLACEHOLDER2,
    imageText: "Adobe India Hackathon",
  },
  {
    file: CERT_PDF1,
    image: CERT_PLACEHOLDER1,
    imageText: "SAP GENERATIVE AI Certification",
  },
  {
    image: CERT_PLACEHOLDER3,
    imageText: "VIT Chennai - Build with AI Workshop and Hackathon",
  },
  // -----
  {
    file: CertPdf2,
    image: CertImg6,
    imageText: "Claude Code 101",
  },
  {
    file: CertPdf3,
    image: CertImg7,
    imageText: "Claude Code in Action",
  },
  {
    file: CertPdf4,
    image: CertImg9,
    imageText: "Claude with Anthropic API",
  },
  {
    file: CertPdf5,
    image: CertImg10,
    imageText: "Quickstart: LangChain Essentials - TypeScript",
  },
  {
    file: CertPdf6,
    image: CertImg11,
    imageText: "Quickstart: LangGraph Essentials - TypeScript",
  },
  {
    file: CertPdf7,
    image: CertImg12,
    imageText: "Project: Deep Agents with LangGraph",
  },
  {
    image: CERT_PLACEHOLDER4,
    imageText: "Walmart Sparkathon",
  },
  {
    image: CERT_PLACEHOLDER5,
    imageText: "MSME idea hackathon Winner",
  },
];

const TRAVEL_EVENTS = [
  {
    body:
      "I enjoy being in spaces where people are building, presenting, and testing ideas. Those rooms teach me how people explain their work.",
    image: EVENT_PLACEHOLDER1,
  },
  {
    body:
      "I enjoy being in spaces where people are building, presenting, and testing ideas. Those rooms teach me how people explain their work.",
    image: EVENT_PLACEHOLDER2,
  },
  {
    body:
      "I enjoy being in spaces where people are building, presenting, and testing ideas. Those rooms teach me how people explain their work.",
    image: EVENT_PLACEHOLDER3,
  },
  {
    body:
      "I enjoy being in spaces where people are building, presenting, and testing ideas. Those rooms teach me how people explain their work.",
    image: EVENT_PLACEHOLDER4,
  },
];

const EXPERIENCES = [
  {
    company: "NukePC",
    location: "Chennai, IND",
    role: "UI/UX Design Intern",
    date: "Dec 2025 - Jan 2026",
    body:
      "Designed mobile-first product flows and worked on interface improvements for custom PC configuration.",
  },
  {
    company: "RMKCET Website",
    location: "Chennai, IND",
    role: "Frontend Developer",
    date: "Aug 2024 - May 2025",
    body:
      "Redesigned and improved a college website with clearer page structure and responsive layouts.",
  },
  {
    company: "ToolAhead",
    location: "Remote",
    role: "AI Intern",
    date: "Jul 2024 - Aug 2024",
    body:
      "Explored AI fundamentals and gained hands-on experience working with AI tools and workflows.",
  },
  {
    company: "MSME Hackathon",
    location: "India",
    role: "Frontend Developer",
    date: "May 2025 - Present",
    body:
      "Built responsive web interfaces and helped shape prototype workflows for a hackathon solution.",
  },
];

function useAutoIndex(length, delay) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (length <= 1) return undefined;

    const timer = window.setInterval(() => {
      setIndex((value) => (value + 1) % length);
    }, delay);

    return () => window.clearInterval(timer);
  }, [length, delay]);

  return [index, setIndex];
}

function ArrowIcon({ direction = "right" }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      style={{ transform: direction === "left" ? "rotate(180deg)" : "none" }}
    >
      <path
        d="M5 12h13"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M13 6l6 6-6 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function FavoriteSongs() {
  const [songIndex, setSongIndex] = useAutoIndex(SONGS.length, 5000);
  const [vinylFront, setVinylFront] = useState(false);
  const vinylTimerRef = useRef(null);
  const song = SONGS[songIndex];

  useEffect(() => {
    return () => window.clearTimeout(vinylTimerRef.current);
  }, []);

  const bringVinylForward = () => {
    window.clearTimeout(vinylTimerRef.current);
    setVinylFront(true);

    vinylTimerRef.current = window.setTimeout(() => {
      setVinylFront(false);
    }, 5000);
  };

  return (
    <section className="about-block about-songs" data-platform>
      <div className="about-section-head">
        <p>01</p>
        <h2>Favourite Songs</h2>
        <span>Rotating quietly while the page sits still.</span>
      </div>

      <div className="song-card">
        <button
          className="about-icon-button song-next"
          type="button"
          onClick={() => setSongIndex((value) => (value + 1) % SONGS.length)}
          aria-label="Next song"
        >
          <ArrowIcon />
        </button>

        <div className={`song-player ${vinylFront ? "is-vinyl-front" : ""}`}>
          <button
            className="vinyl-record"
            type="button"
            onClick={bringVinylForward}
            aria-label="Bring vinyl forward"
          >
            <img className="vinyl-image" src={song.vinyl} alt="" />
            <span
              className="vinyl-label"
              style={{ backgroundImage: `url(${song.cover})` }}
            />
          </button>

          <div
            className="song-cover"
            style={{ backgroundImage: `url(${song.cover})` }}
          />
        </div>

        <div className="song-meta">
          <strong>{song.title}</strong>
          <span>{song.artist}</span>
        </div>
      </div>
    </section>
  );
}

function FavoritesCarousel() {
  const [activeIndex, setActiveIndex] = useAutoIndex(FAVORITES.length, 10000);
  const active = FAVORITES[activeIndex];

  const tickerItems = useMemo(
    () => [...active.items, ...active.items],
    [active.items]
  );

  const shift = (direction) => {
    setActiveIndex((value) => {
      const next = value + direction;
      if (next < 0) return FAVORITES.length - 1;
      return next % FAVORITES.length;
    });
  };

  return (
    <section className="about-block about-favorites" data-platform>
      <div className="about-section-head">
        <p>{activeIndex === 0 ? "02" : "03"}</p>
        <h2>{active.label}</h2>
        <span>{active.subtitle}</span>
      </div>

      <div className="favorites-frame">
        <button
          className="about-icon-button favorites-left"
          type="button"
          onClick={() => shift(-1)}
          aria-label="Previous favorites"
        >
          <ArrowIcon direction="left" />
        </button>

        <div className="favorites-viewport">
          <div className="favorites-track">
            {tickerItems.map((item, index) => (
              <article className="favorite-card" key={`${item.title}-${index}`}>
                <div
                  className="favorite-cover"
                  style={{ backgroundImage: `url(${item.image})` }}
                />
                <p>{item.title}</p>
                {item.author && <span>{item.author}</span>}
              </article>
            ))}
          </div>
        </div>

        <button
          className="about-icon-button favorites-right"
          type="button"
          onClick={() => shift(1)}
          aria-label="Next favorites"
        >
          <ArrowIcon />
        </button>
      </div>
    </section>
  );
}

function CertificationMedia({ item }) {
  const openUrl = item.file
    ? new URL(item.file, window.location.origin).href
    : new URL(item.image, window.location.origin).href;

  return (
    <a
      className="certification-preview-link"
      href={openUrl}
      target="_blank"
      rel="noreferrer"
      aria-label={`Open ${item.imageText}`}
    >
      <img
        className="certification-image"
        src={item.image}
        alt={item.imageText}
      />
    </a>
  );
}

function CertificationsCarousel() {
  const [activeIndex, setActiveIndex] = useAutoIndex(
    CERTIFICATIONS.length,
    10000
  );
  const active = CERTIFICATIONS[activeIndex];

  const shift = (direction) => {
    setActiveIndex((value) => {
      const next = value + direction;
      if (next < 0) return CERTIFICATIONS.length - 1;
      return next % CERTIFICATIONS.length;
    });
  };

  return (
    <section className="about-block about-certifications" data-platform>
      <div className="about-section-head">
        <p>04</p>
        <h2>Certifications</h2>
        <span>Courses, certificates, and learning milestones I keep close.</span>
      </div>

      <div className="certification-frame">
        <button
          className="about-icon-button certification-left"
          type="button"
          onClick={() => shift(-1)}
          aria-label="Previous certification"
        >
          <ArrowIcon direction="left" />
        </button>

        <CertificationMedia item={active} />

        <button
          className="about-icon-button certification-right"
          type="button"
          onClick={() => shift(1)}
          aria-label="Next certification"
        >
          <ArrowIcon />
        </button>
      </div>

      <p className="certification-caption">{active.imageText}</p>
    </section>
  );
}

function IntroPanel() {
  const introImages = [
    USER_PLACEHOLDER1,
    USER_PLACEHOLDER2,
  ];
  const stampImages = [
    STAMP_PLACEHOLDER1,
    STAMP_PLACEHOLDER4,
    STAMP_PLACEHOLDER2,
    STAMP_PLACEHOLDER5,
    STAMP_PLACEHOLDER3,
  ];

  const [activeIndex] = useAutoIndex(introImages.length, 10000);
  const stampRefs = useRef([]);

  const handleMouseMove = (event) => {
    const panel = event.currentTarget;
    const rect = panel.getBoundingClientRect();
    const mouseX = event.clientX - rect.left;
    const mouseY = event.clientY - rect.top;

    stampRefs.current.forEach((stamp) => {
      if (!stamp) return;

      const stampRect = stamp.getBoundingClientRect();
      const stampCenterX = stampRect.left - rect.left + stampRect.width / 2;
      const stampCenterY = stampRect.top - rect.top + stampRect.height / 2;

      const dx = stampCenterX - mouseX;
      const dy = stampCenterY - mouseY;
      const distance = Math.sqrt(dx * dx + dy * dy);

      const maxDistance = 220;
      const maxPush = 18;

      if (distance < maxDistance) {
        const force = (1 - distance / maxDistance) * maxPush;
        const angle = Math.atan2(dy, dx);
        const pushX = Math.cos(angle) * force;
        const pushY = Math.sin(angle) * force;

        stamp.style.setProperty("--mouse-x", `${pushX}px`);
        stamp.style.setProperty("--mouse-y", `${pushY}px`);
      } else {
        stamp.style.setProperty("--mouse-x", `0px`);
        stamp.style.setProperty("--mouse-y", `0px`);
      }
    });
  };

  const handleMouseLeave = () => {
    stampRefs.current.forEach((stamp) => {
      if (!stamp) return;
      stamp.style.setProperty("--mouse-x", `0px`);
      stamp.style.setProperty("--mouse-y", `0px`);
    });
  };

  return (
    <section
      className="about-intro-panel"
      data-platform
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <div className="intro-stamps" aria-hidden="true">
        {stampImages.map((image, index) => (
          <span
            key={index}
            ref={(node) => {
              stampRefs.current[index] = node;
            }}
            className={`intro-stamp intro-stamp--${index + 1}`}
            style={{ backgroundImage: `url(${image})` }}
          />
        ))}
      </div>

      <div className="intro-copy">
        <p className="intro-kicker">About Me</p>
        <h1>Hi, I am Ragav.</h1>
        <p>
          I am a designer and developer building product stories with
          interaction, clarity, and small moments of delight. I like turning
          rough ideas into interfaces that feel thoughtful, usable, and alive.
          My work usually sits between product design, frontend development,
          and playful systems.
        </p>
      </div>

      <div className="intro-image-slider">
        {introImages.map((image, index) => (
          <div
            key={image}
            className={`intro-image-slide ${
              index === activeIndex ? "is-active" : ""
            }`}
            style={{ backgroundImage: `url(${image})` }}
          />
        ))}
      </div>
    </section>
  );
}

function TravelExperience() {
  const [activeIndex, setActiveIndex] = useAutoIndex(
    TRAVEL_EVENTS.length,
    10000
  );
  const active = TRAVEL_EVENTS[activeIndex];

  const shift = (direction) => {
    setActiveIndex((value) => {
      const next = value + direction;
      if (next < 0) return TRAVEL_EVENTS.length - 1;
      return next % TRAVEL_EVENTS.length;
    });
  };

  return (
    <section className="about-block about-travel" data-platform>
      <div className="about-section-head">
        <p>05</p>
        <h2>Travel and Event Experience</h2>
        <span>{active.body}</span>
      </div>

      <div className="travel-frame">
        <button
          className="about-icon-button travel-left"
          type="button"
          onClick={() => shift(-1)}
          aria-label="Previous travel slide"
        >
          <ArrowIcon direction="left" />
        </button>

        <div
          className="travel-image"
          style={{ backgroundImage: `url(${active.image})` }}
        />

        <button
          className="about-icon-button travel-right"
          type="button"
          onClick={() => shift(1)}
          aria-label="Next travel slide"
        >
          <ArrowIcon direction="right" />
        </button>
      </div>
    </section>
  );
}

function ProfessionalExperience() {
  return (
    <section className="about-block about-experience" data-platform>
      <div className="about-section-head">
        <p>06</p>
        <h2>Experience</h2>
        <span>
          A compact view of the work, internships, and build spaces that shaped
          my current practice.
        </span>
      </div>

      <div className="experience-list">
        {EXPERIENCES.map((item) => (
          <article
            className="experience-row"
            key={`${item.company}-${item.date}`}
          >
            <div>
              <strong>{item.company}</strong>
              <span>{item.location}</span>
            </div>

            <p>{item.role}</p>
            <time>{item.date}</time>
            <small>{item.body}</small>
          </article>
        ))}
      </div>
    </section>
  );
}

export default function AboutMe() {
  return (
    <div className="about-page">
      <div className="about-page-shell">
        <Sidebar />

        <div className="about-page-flow">
          <main className="about-me-page">
            <div className="about-left-column">
              <FavoriteSongs />
              <FavoritesCarousel />
              <CertificationsCarousel />
            </div>

            <IntroPanel />

            <div className="about-right-column">
              <TravelExperience />
              <ProfessionalExperience />
            </div>
          </main>
        </div>
      </div>

      <PortfolioFooter />
    </div>
  );
}
